// โปรเจกชัน Equal Earth (docs/PLAN.md ข้อ 4.4) รักษาสัดส่วนพื้นที่ ขั้วโลกจึงไม่ดูใหญ่เกินจริง
// สูตรจาก Šavrič, Patterson & Jenny (2018) เขียนเองแทน d3-geo เพื่อไม่ต้องส่งไลบรารีให้เบราว์เซอร์
// พิกัดบนแผนที่: x 0 ถึง MAP_WIDTH จากตะวันตกไปตะวันออก, y 0 ถึง MAP_HEIGHT จากเหนือลงใต้

const A1 = 1.340264;
const A2 = -0.081106;
const A3 = 0.000893;
const A4 = 0.003796;
const M = Math.sqrt(3) / 2;
const RAD = Math.PI / 180;

function raw(lon: number, lat: number): [number, number] {
  const l = lon * RAD;
  const t = Math.asin(M * Math.sin(lat * RAD));
  const t2 = t * t;
  const t6 = t2 * t2 * t2;
  const x = (l * Math.cos(t)) / (M * (A1 + 3 * A2 * t2 + t6 * (7 * A3 + 9 * A4 * t2)));
  const y = t * (A1 + A2 * t2 + t6 * (A3 + A4 * t2));
  return [x, y];
}

const X_MAX = raw(180, 0)[0];
const Y_MAX = raw(0, 90)[1];

export const MAP_WIDTH = 1000;
export const MAP_HEIGHT = Math.round((MAP_WIDTH * Y_MAX) / X_MAX * 10) / 10;

/** แปลงลองจิจูด/ละติจูด (องศา) เป็นตำแหน่งบนแผนที่ */
export function project(lon: number, lat: number): [number, number] {
  const [x, y] = raw(lon, lat);
  return [((x + X_MAX) / (2 * X_MAX)) * MAP_WIDTH, ((Y_MAX - y) / (2 * Y_MAX)) * MAP_HEIGHT];
}
